import { supabase } from '../services/supabase';

// Cache admin authorization checks to avoid repeated database queries
const authCache = new Map<string, { isAdmin: boolean; timestamp: number }>();
const CACHE_TTL = 5 * 60 * 1000; // 5 minutes

/**
 * Check if an email is authorized as an admin
 * @param email - The email to check
 * @returns true if the email exists in the admins table
 */
export async function isAuthorizedAdmin(email: string): Promise<boolean> {
  // Check cache first
  const cached = authCache.get(email);
  if (cached && Date.now() - cached.timestamp < CACHE_TTL) {
    return cached.isAdmin;
  }

  const { data, error } = await supabase
    .from('admins')
    .select('email')
    .eq('email', email)
    .maybeSingle();

  if (error) {
    throw new Error(`Failed to check admin authorization: ${error.message}`);
  }

  const isAdmin = !!data;

  // Cache the result
  authCache.set(email, { isAdmin, timestamp: Date.now() });

  return isAdmin;
}
